// extracted by mini-css-extract-plugin
export var buttonsWrapper = "styles-module--buttonsWrapper--cf669";
export var gradientWrapper = "styles-module--gradientWrapper--2b92f";
export var title = "styles-module--title--3a562";